/* eslint-disable react/prop-types */
import React from 'react';

const GRID_TYPES = {
  BUILDER_CONSTRUCTOR_GRID: 'BUILDER_CONSTRUCTOR_GRID',
  CONSTRUCTOR_SEARCH_GRID: 'CONSTRUCTOR_SEARCH_GRID',
  PRODUCTS_V2_GRID: 'PRODUCTS_V2_GRID',
};

const GridInputContext = React.createContext();

const useGridInputs = () => {
  return React.useContext(GridInputContext) || {};
};

const GridInputProvider = ({ children, value }) => {
  return (
    <GridInputContext.Provider value={value}>
      {children}
    </GridInputContext.Provider>
  );
};

export default useGridInputs;
export { GridInputProvider, GRID_TYPES };
